import React, { useState, useRef } from "react";

interface EditableNameProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  placeholder?: string;
}

export default function EditableName({
  value,
  onChange,
  className = "",
  placeholder = "Enter name",
}: EditableNameProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);

  const startEdit = () => {
    setEditValue(value);
    setIsEditing(true);
    setTimeout(() => inputRef.current?.focus(), 0);
  };

  const save = () => {
    onChange(editValue);
    setIsEditing(false);
  };

  const cancel = () => {
    setEditValue(value);
    setIsEditing(false);
  };

  if (isEditing) {
    return (
      <input
        ref={inputRef}
        type="text"
        value={editValue}
        onChange={(e) => setEditValue(e.target.value)}
        onBlur={save}
        onKeyDown={(e) => {
          if (e.key === "Enter") save();
          if (e.key === "Escape") cancel();
        }}
        placeholder={placeholder}
        className={`w-full bg-transparent border border-slate-300 dark:border-slate-600 rounded-md px-3 py-2 focus:outline-none focus:border-indigo-500 dark:focus:border-indigo-400 ${className}`}
      />
    );
  }

  return (
    <div
      className={`cursor-pointer border-b-2 border-dashed border-gray-300 dark:border-gray-600 hover:border-blue-500 dark:hover:border-blue-400 pb-1 transition-colors ${className}`}
      onClick={startEdit}
      title="Click to edit"
    >
      {value}
    </div>
  );
}
